import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const AddProduct = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const product_detail = JSON.parse(localStorage.getItem("product-list"));
  const storedProductDetail = product_detail;
  const BASE_IMAGE_URL = `${BASE_URL}/`;
  const [initialImagePath, setInitialImagePath] = useState(null);
  const isEditMode = storedProductDetail?.id;

  useEffect(() =>{
    fetchCategory()
  },[])

  useEffect(() => {
    if (storedProductDetail && storedProductDetail?.id) {
      setFormData((prev) => ({
        ...prev,
        id: storedProductDetail.id || "",
        name: storedProductDetail.name || "",
        description: storedProductDetail.description || "",
        category_id:storedProductDetail.category_id || "",
      }));

      if (storedProductDetail.image) {
        const fullPath = storedProductDetail.image.startsWith("http")
          ? storedProductDetail.image
          : `${BASE_IMAGE_URL}${storedProductDetail.image}`;

        setPreview(fullPath);
        setInitialImagePath(fullPath);
      }
    } else {
      setFormData([]);
    }
  }, [isEditMode]); 

  const history = useHistory();
  const [formData, setFormData] = useState({
    name: "",
    image: "",
    description: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [categories, setCategory] = useState([]);
  const [error, setError] = useState(null);
  
    const fetchCategory = async () => {
    try {
      
      const response = await api.post("/category/get")
      if (response.data.success) {
        setCategory(response.data.category);
      } else {
        setError("Category not found");
      }
    } catch (err) {
      setError("Error fetching Category details");
    } finally {
     
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(e.target.files[0]);
    if (file) {
      setPreview(URL.createObjectURL(file)); 
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
      data.append("category_id", formData.category_id ? formData.category_id : "");
    data.append("name", formData.name ? formData.name : "");
    data.append(
      "description",
      formData.description ? formData.description : ""
    );

    if (image) {
      data.append("image", image);
    }
    try {
      let response;
      let url;
      let method; 

      if (isEditMode) {
        url = `/product/update/${isEditMode}`;
        method = api.post; 
      } else {
        url = `/product/create`; 
        method = api.post;
      }

      response = await method(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const successMessage = isEditMode
          ? "Product updated successfully!"
          : "Product added successfully!";

        toast.success(successMessage);
        localStorage.removeItem("product-list");
        history.push("/product");
      } else {
        toast.error(
          "Submission failed: " + (response.data.message || "Unknown error.")
        );
      }
    } catch (err) {
      const apiErrors = err.response?.data?.errors;
      if (apiErrors) {
        toast.error(
          "Validation failed: " + Object.values(apiErrors).flat().join(" | ")
        );
      } else {
        toast.error("Error submitting product!");
      }
    }
  };
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>
              {isEditMode
                ? "Edit Product Categories"
                : "Add Product Categories"}
            </h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/dashboard">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">
                  {isEditMode ? "Edit product" : " Add product"}
                </div>
              </li>
            </ul>
          </div>
          {/* <!-- form-add-product --> */}
          <form
            className="tf-section-2 form-add-product"
            onSubmit={handleSubmit}
          >
            
            <div className="wg-box">
               <fieldset className="category_id">
                <div class="body-title mb-10"> Category Name </div>
                <div class="select">
                  <select
                    name="category_id"
                    id="category_id"
                    value={formData.category_id}
                    onChange={handleChange}
                  >
                    <option>Select Category</option>
                    {categories.map((element) => {
                      return (
                        <option value={element.id}>{element?.name}</option>
                      );
                    })}
                  </select>
                </div>
              </fieldset>
               <fieldset className="name">
                <div className="body-title mb-10">
                 Product Category Name <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter category name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </fieldset>
              <fieldset className="mt-4">
                <div className="body-title mb-10">Upload Image</div>

                <input
                  type="file"
                  id="myFile"
                  name="image"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 p-2"
                />

                {preview && (
                  <div className="mt-4">
                    <img
                      src={preview}
                      alt="Preview"
                      className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                    />
                  </div>
                )}
              </fieldset>

              <div className="cols gap10 mt-4">
                <button className="tf-button style-1 w-full" type="submit">
                  Save Product
                </button>
              </div>
            </div>
          </form>
          {/* <!-- /form-add-product --> */}
        </div>
        {/* <!-- /main-content-wrap --> */}
      </div>
    </>
  );
};
export default AddProduct;
